export default __webpack_public_path__ + "53aa61522c5dd5c76b2335ac0242638e.png";